export default "__VITE_ASSET__DuzaGjnZ__"